import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Typography } from '@material-ui/core'
import IntlMessages from '@crema/utility/IntlMessages'
import RedButton from 'components/Button/RedButton'
import NormalTable from 'components/Table/NormalTable'
import StaffProfileTable from 'components/Temple/StaffProfileTable'
import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import {
    selectCurrentTempleStaffProfiles,
    selectStaffProfileStatus,
    staffProfileDeleteThunk,
    staffProfileListThunk,
} from 'store/reducers/temple/staffProfileSlice'
import { StaffProfileResponseType } from 'types/api/temple'
import usePermissionCheck from 'hooks/usePermissionCheck'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'

const ListStaffProfile: React.FC<RouteComponentProps> = ({ history, location }) => {
    const dispatch = useAppDispatch()
    const profiles = useAppSelector(selectCurrentTempleStaffProfiles)
    const api = useAppSelector(selectStaffProfileStatus)
    const permissions = usePermissionCheck(RESTRICTED_PATHS.STAFF_PROFILES)
    const [deleteItem, setDeleteItem] = useState<StaffProfileResponseType | null>(null)
    const [deletingIds, setDeletingIds] = useState<(string | number)[]>([])

    useEffect(() => {
        dispatch(staffProfileListThunk({}))
    }, [dispatch])

    const handleDelete = (canDelete?: boolean) => {
        if (canDelete && deleteItem) {
            setDeletingIds(prev => [...prev, deleteItem.id])
            dispatch(staffProfileDeleteThunk({ id: deleteItem.id }))
                .finally(() => {
                    setDeletingIds(prev => prev.filter(id => id !== deleteItem.id))
                    setDeleteItem(null)
                })
        } else {
            setDeleteItem(null)
        }
    }

    return (
        <Paper>
            <NormalTable
                api={api}
                toolbar={
                    <Box display='flex' justifyContent='space-between' p={5}>
                        <Typography variant='h6'>Staff & Priest Profiles</Typography>
                        {permissions.includes(PERMISSIONS.ADD) && (
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => history.push(`${location.pathname}/add`)}
                            >
                                Add Profile
                            </Button>
                        )}
                    </Box>
                }
            >
                <StaffProfileTable
                    profiles={profiles}
                    editHandler={permissions.includes(PERMISSIONS.CHANGE) ? id => history.push(`${location.pathname}/edit/${id}`) : undefined}
                    deleteHandler={permissions.includes(PERMISSIONS.DELETE) ? id => {
                        const profile = profiles.find(item => item.id === id)
                        if (profile) setDeleteItem(profile)
                    } : undefined}
                    deletingIds={deletingIds}
                />
            </NormalTable>
            <Dialog open={Boolean(deleteItem)}>
                <DialogTitle>{`Delete ${deleteItem?.fullName}?`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Deleting this profile removes it from staff/priest assignment options.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='primary' onClick={() => handleDelete(false)}>
                        <IntlMessages id='common.cancel' />
                    </Button>
                    <RedButton variant='outlined' onClick={() => handleDelete(true)} autoFocus>
                        <IntlMessages id='common.delete' />
                    </RedButton>
                </DialogActions>
            </Dialog>
        </Paper>
    )
}

export default ListStaffProfile
